
<v-menu offset-y v-if="inspection">
    <template v-slot:activator="{ on, attrs }">
        <a
            v-bind = "attrs"
            v-on   = "on"
            class  = "audit-menu"
        >
            <v-icon color="white" size="24">mdi-menu</v-icon>
        </a>
    </template>

    <div class="white">
        <v-list class="white">
            <v-list-item
                v-for = "(entry, index) in menu"
                :key  = "index"
                link
            >
                <v-list-item-title
                    @click = "onMenu(entry)"
                    class  = "v-flex"
                >
                    <div style="margin-top: -2px; margin-right: 8px;">
                        <v-icon
                            size   = "18"
                            :color = "entry.available ? 'black' : 'secondary'"
                        >
                            {{ entry.icon }}
                        </v-icon>
                    </div>

                    <div
                        style  = "width: 110px"
                        :class = "entry.available ? 'black--text' : 'secondary--text'"
                    >
                        {{ entry.name }}
                    </div>

                    <div
                        v-if   = "!isImage (entry) && entry.available"
                        class  = "menu-status"
                    >
                        <v-icon size="24" :color="statusColor (entry.status)">{{ statusIcon (entry.status) }}</v-icon>
                    </div>

                    <div
                        v-if   = "isImage(entry)"
                        :class = "entry.available ? 'black--text' : 'secondary--text'"
                    >
                        {{ entry.data.length + " Bilder" }}
                    </div>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</v-menu>

